import {formatTime} from './index'

// 设置层级
export function setStage(list, parentStage){
    let stage = parentStage ? (parentStage + '.') : ''
    if(list && list.length){
      list.map((item, index)=>{
        if(!item.stage){
			// item.stage = stage + (index +1)
			item.stage = stage + item.orderNum
			// item.id = item.id || Math.round(Math.random()*99999)
        }
        if(item.children && item.children.length){
			item.isLeaf = false
			item.children = setStage(item.children, item.stage)
			if(item.children.children){
				item.children.children = setStage(item.children.children, item.children.stage)
			}
        }else {
			item.isLeaf = true
		}
      });
    }
    return list
}

// 计算2个日期的天数，包括今天
export function dateDiff(startDateString, endDateString) {
	var separator = "-"; //日期分隔符
    var startDates = formatTime(startDateString, 'Y-M-D').split(separator)
    var endDates = formatTime(endDateString, 'Y-M-D').split(separator)
    var startDate = new Date(startDates[0], startDates[1]-1, startDates[2])
    var endDate = new Date(endDates[0], endDates[1]-1, endDates[2])
    return parseInt(Math.abs(endDate - startDate ) / 1000 / 60 / 60 /24) + 1 //把相差的毫秒数转换为天数
}

// 树形转线形
export function changeTreeDataToList(treeData, listTreeData) {
	let list = listTreeData ? listTreeData : []
	if(treeData && treeData.length) {
		treeData.map( item => {
			if(item.children && item.children.length) {
				changeTreeDataToList(item.children, list)
			}
			let itemTreeData = {}
			itemTreeData = _.cloneDeep(item)
			delete itemTreeData.children
			list.push(itemTreeData)
		})
	}
	return list
}








// WEBPACK FOOTER //
// ./src/util/projectTree.js